import { render } from "./MenuCol.vue?vue&type=template&id=53363d9e&scoped=true"
import script from "./MenuCol.vue?vue&type=script&lang=js"
export * from "./MenuCol.vue?vue&type=script&lang=js"

import "./MenuCol.vue?vue&type=style&index=0&id=53363d9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53363d9e"]])

export default __exports__